var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile" }, [
      _c("div", { staticClass: "tile is-parent is-half" }, [
        _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _vm.isLabourActive
              ? _c("item-detail-labour", {
                  attrs: { active: _vm.isLabourActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isLabourActive = $event
                    },
                    changeType: _vm.changeType,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                })
              : _vm._e(),
            _vm.isPartActive
              ? _c("item-detail-part", {
                  attrs: { active: _vm.isPartActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isPartActive = $event
                    },
                    changeType: _vm.changeType,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                })
              : _vm._e(),
            _vm.isOpgActive
              ? _c("item-detail-opg", {
                  attrs: { active: _vm.isOpgActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isOpgActive = $event
                    },
                    changeType: _vm.changeType,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                })
              : _vm._e(),
            _vm.isMiscActive
              ? _c("item-detail-misc", {
                  attrs: { active: _vm.isMiscActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isMiscActive = $event
                    },
                    changeType: _vm.changeType,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                })
              : _vm._e(),
            _vm.isSubletActive
              ? _c("item-detail-sublet", {
                  attrs: { active: _vm.isSubletActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isSubletActive = $event
                    },
                    changeType: _vm.changeType,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }